(function ($) {
    var HIDE_POPUP = false;
    var IS_VERIFY = false;
    var IS_JOIN = false;

    var MESSAGE = {
        'error-reject': {
            title: '사용할 수 없는 SNS계정입니다.',
            message: '다른 계정으로 다시 시도해 보세요!',
            type: 'alert'
        },
        'error-provider': {
            title: '계정을 연결하지 못했습니다.',
            message: '다시 시도해 주세요!',
            type: 'alert'
        },
        'error-not_kakao_signup': {
            title: '가입되어 있지 않은 SNS 계정입니다.',
            message: 'SNS 계정 정보를 확인 후, 다시 로그인 시도해주세요.',
            type: 'alert'
        },

        //welcome
        'success-kakaosignup': {
            type: 'welcome',
            title: '브런치에 오신 것을 환영합니다.',
            message: '이용 안내를 확인하고 브런치 채널로<br>주요 소식을 빠짐없이 받아보세요.',
            actions: [
                { class: 'btn_primary', action: 'goBrunchGuide', name: '서비스 이용안내' },
                { class: '', action: 'goTalkChannel', name: '브런치 채널추가' }
            ]
        },

        // 계정연결
        'success-connectKakaoAccount': {
            type: 'connect',
            title: '이메일로 카카오계정 연결메일이<br>발송되었습니다.<br>72시간 내에 연결을 완료해주세요!',
            actions: [
                { class: 'btn_ok', action: 'ok', name: '확인' }
            ],
            hasClose: false
        },
        'error-alreadyHasKakaoAccount': {
            type: 'connect',
            title: '이미 카카오계정이 연결되어 있습니다.<br>카카오계정으로 로그인해주세요.',
            actions: [
                { class: 'btn_ok', action: 'signin', name: '로그인 하러 가기' }
            ],
            hasClose: true
        },
        'error-connectEmailNotFound': {
            type: 'connect',
            title: '가입되어 있지 않은 이메일입니다.',
            message: '정확한 이메일 주소를 확인한 후 다시 시도해주세요.',
            actions: [
                { class: 'btn_ok', action: 'ok', name: '확인' }
            ],
            hasClose: false
        },
        'error-noMatchingUser': {
            type: 'connect',
            title: '조건에 맞는 유저가 없습니다. 다시 선택해주세요.',
            actions: [
                { class: 'btn_ok', action: 'ok', name: '확인' }
            ],
            hasClose: false
        },
        'error-alreadyConnectedToExistingUser': {
            type: 'connect',
            title: '계정 연결에<br>실패했습니다.',
            message: '이미 다른 브런치에 연결되어 있는<br>카카오계정은 사용하실 수 없습니다.',
            actions: [
                { class: 'btn_ok', action: 'ok', name: '확인' }
            ],
            hasClose: false
        },
        'success-connect': {
            type: 'connect',
            title: '카카오계정을\n연결하였습니다.',
            message: '앞으로 브런치 로그인 시,<br>해당 카카오계정을 계속 이용해주세요!',
            actions: [
                { class: 'btn_ok', action: 'signin', name: '로그인하러 가기' }
            ],
            hasClose: true
        },


        // 계정찾기
        'success-findAccountSend': {
            type: 'connect',
            title: '카카오계정 찾기 메일이<br>발송되었습니다.',
            message: '수신된 메일에서 카카오계정 아이디를 확인하고<br>브런치에 로그인해주세요.',
            actions: [
                { class: 'btn_ok', action: 'goEmailService', name: '메일함 열기' }
            ],
            hasClose: true
        },
        'error-findAccountEmailNotFound': {
            type: 'connect',
            title: '메일 주소를 다시 확인해주세요.',
            message: '브런치 연락처 이메일로 등록되지 않은 메일 주소입니다.<br>정확한 메일 주소를 입력해주세요.',
            actions: [
                { class: 'btn_ok', action: 'ok', name: '확인' }
            ]
        },
        'error-findAccountUnknown': {
            type: 'connect',
            title: '일시적인 오류가 발생했습니다.',
            message: '잠시 후 다시 시도해주세요.',
            actions: [
                { class: 'btn_ok', action: 'ok', name: '닫기' }
            ]
        },

        // 연락처 이메일
        'success-verifyVerification': {
            title: '연락처 이메일이 인증되었습니다.',
            message: '이제 모든 브런치 활동의 메일 알림은 연락처 이메일로 발송됩니다.',
            actions: [
                { class: 'btn_ok', action: 'ok', name: '확인' }
            ]
        },
        'success-verifyChangeEmail': {
            title: '연락처 이메일이 변경되었습니다.',
            message: '이제 모든 브런치 활동의 메일 알림은<br>변경된 연락처 이메일로 발송됩니다.',
            actions: [
                { class: 'btn_ok', action: 'ok', name: '확인' }
            ]
        },
        'error-verifyDuplicateEmail': {
            title: '이미 인증된 이메일입니다.',
            message: '브런치 로그인 후 설정에서 연락처 이메일 설정 상태를 확인하세요.',
            actions: [
                { class: 'btn_ok', action: 'ok', name: '확인' }
            ]
        },
        'error-verifyExpired': {
            title: '인증 시간이 만료되었습니다.',
            message: '브런치 로그인 후 설정에서 연락처 이메일을 다시 설정해 주세요.',
            actions: [
                { class: '', action: 'goSetting', name: '브런치 로그인' }
            ]
        },
        'error-verifyUnknown': {
            title: '일시적인 오류로 인증에 실패했습니다.',
            message: '잠시 후 다시 시도해 주세요.',
            actions: [
                { class: 'btn_ok', action: 'ok', name: '확인' }
            ]
        },

        'success-specific': {
            title: '이메일이 인증되었습니다.',
            message: '글 발행, 브런치 주소 변경, 계정 찾기 등<br>서비스를 자유롭게 이용하실 수 있습니다.',
            actions: [
                { class: '', action: 'ok', name: '브런치 둘러보기' }
            ]
        },

        'success-proposeBlock': {
            title: '제안 받지 않도록 차단했습니다.',
            message: '이 사람에게 다시 제안을 받으려면, 고객센터로 문의해 주세요.',
            actions: [
                { class: 'btn_ok', action: 'ok', name: '확인' }
            ]
        },

        'success-collabo': {
            title: '참여작가가 되었습니다!',
            message: '콜라보레이션 프로젝트<br>매거진에 글을 발행해 보세요.'
        },
        'success-sleepUserLogin': {
            title: '휴면이 해제되었습니다.',
            message: '휴면 전과 동일하게 브런치의<br>모든 기능을 사용하실 수 있습니다.',
            actions: [
                { class: 'btn_in_beta_layer', action: 'ok', name: '확인' }
            ]
        },
        'success-weeklyMagazineApplyWait': {
            title: '곧 신청한 작품 검토가 시작됩니다.',
            message: '검토 중에는 수정이 불가능 하오니<br>신중하게 수정해 주세요.',
            actions: [
                { class: 'btn_close', action: 'close', name: '취소' },
                { class: 'btn_ok', name: '확인' }
            ],
            layerClass: 'weekly_magazine_modify'
        },
        'success-weeklyMagazineApply': {
            title: '이미 작품에 대한 심사가 시작되어,<br>수정이 불가합니다.',
            message: '검토 결과는 약 30일 내에,<br>이메일로 안내해 드리겠습니다.',
            actions: [
                { class: 'btn_ok', action: 'ok',  name: '확인' }
            ]
        },

        'error-needAuthorApply': {
            title: '작가 신청을 해주세요',
            message: '브런치 작가가 되면 <br> 책방에 내 책을 등록할 수 있습니다.',
            actions: [
                { class: 'btn_request', action: 'goRequest', name: '브런치 작가 신청하기' }
            ]
        },
        'error-needAuthorApplyForPass': {
            title: '브런치 무비 패스는 <br>작가만 참여하실 수 있습니다.',
            message: '브런치 작가신청을 하시겠습니까?',
            actions: [
                { class: 'btn_close', action: 'close', name: '취소' },
                { class: 'btn_request', action: 'goRequest', name: '작가신청' }
            ],
            layerClass: 'brunch_pass'
        },
        'error-emptySaveArticle': {
            title: '브런치<br>저장글이 없습니다.',
            message: '브런치 작가 신청 시 저장글은 심사 자료 중<br/>가장 중요한 자료가 됩니다.',
            actions: [
                { class: 'btn_close', action: 'goRequestDirect', name: '바로 신청하기' },
                { class: 'btn_request', action: 'goWrite', name: '저장글 쓰러가기' }
            ],
            layerClass: 'empty_save_article'
        },
        'success-authorUsingCard': {
            title: '브런치 작가가 되신 것을<br> 진심으로 축하드립니다!',
            message: '작가 전용 프로필로 변경되었습니다.<br>다양한 기회를 제안 받을 수 있도록 본인을 표현해 보세요.',
            actions: [
                {
                    class: '',
                    action: 'goProfileNotice',
                    name: '프로필 활용 방법' },
                {
                    class: '',
                    action: 'goMyHome',
                    name: '내 브런치로 이동'
                }
            ]
        },

        'connect-kakao': {
            title: '카카오계정을 연결하시겠습니까?',
            message: '선택 정보 수집에 동의하시려면 카카오계정 연결이 필요합니다.<br>계정 연결 후 선택 정보 수집에 동의하시면 나와 유사한 독자들이<br>좋아한 작품도 함께 추천 받을 수 있습니다.',
            actions: [
                { class: 'btn_close', action: 'close', name: '나중에' },
                { class: '', action: 'goConnectKakao', name: '지금 연결하기' }
            ]
        },

        'success-newBrunchbook': {
            title: '발간하지 않은 브런치북은<br>PC 작가의 서랍에 저장됩니다.',
            message: '저장해두었다가 작품을 완성했을 때 최종 발간하실 수 있습니다.',
            actions: [
                { class: '', action: 'goReadyBrunchbook', name: '작가의 서랍 확인하기' }
            ]
        },

        'error-alreadyAuthorUsingCard': {
            title: '이미 브런치 작가이셨군요!',
            message: '다양한 기회를 제안 받을 수 있도록<br>작가님의 프로필에서 본인을 더 잘 표현해 보세요.',
            actions: [
                {
                    class: '',
                    action: 'goProfileNotice',
                    name: '프로필 활용 방법'
                },
                {
                    class: '',
                    action: 'goMyHome',
                    name: '내 브런치로 이동'
                }
            ]
        },
        'error-default': {
            title: '오류가 발생하였습니다.',
            type: 'alert'
        },
        'error-notExistTokenUsingCard': {
            title: '존재하지 않는 초대카드입니다.',
            type: 'alert'
        },
        'error-alreadyAcceptedUsingCardForAccepter': {
            title: '아쉽지만 다른 분이 카드를 사용했어요.',
            message: '신청을 통해 브런치 작가가 되어 보세요!',
            type: 'alert'
        },
        'error-alreadyAcceptedUsingCardForSender': {
            title: '추천하신 분이 브런치 작가가 됐어요.',
            message: '두 분의 창작 활동을 응원하겠습니다!',
            type: 'alert'
        },
        'error-expiredUsingCardForSender': {
            title: '아쉽지만 작가 초대 기한이 지났어요.',
            message: '다른 방법으로 브런치를 추천해 주세요!',
            type: 'alert'
        },
        'error-expiredUsingCardForAccepter': {
            title: '아쉽지만 작가 초대 기한이 지났어요.',
            message: '신청을 통해 브런치 작가가 되어 보세요!',
            type: 'alert'
        },
        'error-weeklyMagazineAcceptPropose': {
            title: "연재 신청 전<br>'제안하기'를 켜주세요.",
            message: "프로필 편집에서 제안하기를 켜두어야 신청하실 수 있습니다.<br>심사 후 출판/미팅을 희망하는 출판사는 '제안하기'로 연락 드립니다.",
            actions: [
                { class: '', action: 'goWeeklyMagazineNotice', name: '신청 안내 보기' },
                { class: 'btn_request',  action: 'goProfile', name: '제안하기 켜기'  }
            ]
        },
        'success-checkConnectKakao': {
            title: '카카오계정을 정말<br> 연결하시겠습니까?',
            message: '해당 계정은 카톡에서 쓰는 계정이 아닙니다.<br>톡 계정을 연결하면 더 원활하게<br>브런치를 이용하실 수 있습니다.',
            actions: [
                { class: '', action: 'goCheckKakao', name: '계정 확인' },
                { class: '', action: 'goReConnectKakao', name: '연결하기' }
            ]
        }
    };

    var DEFAULT_MOBILE_CLOSE_BTN = { class: '', action: 'close', name: '닫기' };


    var MESSAGE_MOBILE = {

        'error-reject': {
            title: '사용할 수 없는<br>SNS계정입니다.',
            message: '다른 계정으로 다시 시도해 보세요!'
        },
        'error-provider': {
            title: '계정을 연결하지 못했습니다.',
            message: '다시 시도해 주세요!'
        },
        'error-not_kakao_signup': {
            title: '가입되어 있지 않은 SNS 계정입니다.',
            message: 'SNS 계정 정보를 확인 후, 다시 로그인 시도해주세요.',
            type: 'alert'
        },

        //welcome
        'success-kakaosignup': {
            type: 'welcome',
            title: '브런치에 오신 것을 환영합니다.',
            message: '이용 안내를 확인하고 브런치 채널로<br>주요 소식을 빠짐없이 받아보세요.',
            actions: [
                { class: 'btn_primary', action: 'goBrunchGuide', name: '이용 안내' },
                { class: 'btn_channel', action: 'goTalkChannel', name: '<span class="ico_brunch_v1">카카오톡</span>채널추가' }
            ]
        },

        // 계정연결
        'success-connectKakaoAccount': {
            type: 'connect',
            title: '이메일로 카카오계정 연결메일이<br>발송되었습니다.<br>72시간 내에 연결을 완료해주세요!',
            actions: [
                { class: 'btn_ok', action: 'ok', name: '확인' }
            ]
        },
        'error-alreadyHasKakaoAccount': {
            type: 'connect',
            title: '이미 카카오계정이 연결되어 있습니다.<br>카카오계정으로 로그인해주세요.',
            actions: [
                { class: 'btn_ok', action: 'signin', name: '로그인 하러 가기' }
            ]
        },
        'error-connectEmailNotFound': {
            type: 'connect',
            title: '가입되어 있지 않은 이메일입니다.',
            message: '정확한 이메일 주소를 확인한 후 다시 시도해주세요.',
            actions: [
                { class: 'btn_ok', action: 'ok', name: '확인' }
            ]
        },
        'error-noMatchingUser': {
            type: 'connect',
            title: '조건에 맞는 유저가 없습니다. 다시 선택해주세요.',
            actions: [
                { class: 'btn_ok', action: 'ok', name: '확인' }
            ]
        },

        // 계정찾기
        'success-findAccountSend': {
            type: 'connect',
            title: '카카오계정 찾기 메일이<br>발송되었습니다.',
            message: '수신된 메일에서 카카오계정 아이디를 확인하고<br>브런치에 로그인해주세요.',
            actions: [
                { class: 'link_comm2', action: 'ok', name: '닫기' },
                { action: 'goEmailService', name: '메일함 열기' }
            ]
        },
        'error-findAccountEmailNotFound': {
            type: 'connect',
            title: '메일 주소를 다시 확인해주세요.',
            message: '브런치 연락처 이메일로<br>등록되지 않은 메일 주소입니다.<br>정확한 메일 주소를 입력해주세요.',
            actions: [
                { class: 'btn_ok', action: 'ok', name: '확인' }
            ]
        },
        'error-findAccountUnknown': {
            type: 'connect',
            title: '일시적인 오류가 발생했습니다.',
            message: '잠시 후 다시 시도해주세요.',
            actions: [
                { class: 'btn_ok', action: 'ok', name: '닫기' }
            ]
        },
        'error-alreadyConnectedToExistingUser': {
            type: 'connect',
            title: '계정 연결에<br>실패했습니다.',
            message: '이미 다른 브런치에 연결되어 있는<br>카카오계정은 사용하실 수 없습니다.',
            actions: [
                { class: 'btn_ok', action: 'ok', name: '확인' }
            ]
        },
        'success-connect': {
            type: 'connect',
            title: '카카오계정을\n연결하였습니다.',
            message: '앞으로 브런치 로그인 시,<br>해당 카카오계정을 계속 이용해주세요!',
            actions: [
                { class: 'btn_ok', action: 'signin', name: '로그인하러 가기' }
            ]
        },

        // 연락처 이메일
        'success-verifyVerification': {
            title: '연락처 이메일이 인증되었습니다.',
            message: '이제 모든 브런치 활동의 메일 알림은<br>연락처 이메일로 발송됩니다.'
        },
        'success-verifyChangeEmail': {
            title: '연락처 이메일이 변경되었습니다.',
            message: '이제 모든 브런치 활동의 메일 알림은<br>변경된 연락처 이메일로 발송됩니다.'
        },
        'error-verifyDuplicateEmail': {
            title: '이미 인증된 이메일입니다.',
            message: "브런치 로그인 후 '설정'에서 연락처 이메일 설정 상태를 확인하세요."
        },
        'error-verifyExpired': {
            title: '인증 시간이 만료되었습니다.',
            message: "브런치 로그인 후 '설정'에서<br>연락처 이메일을 다시 설정해 주세요.",
            actions: [
                DEFAULT_MOBILE_CLOSE_BTN,
                { class: 'link_comm', action: 'goAppPage', name: '앱 설정 열기' }
            ]
        },
        'error-verifyUnknown': {
            title: '일시적인 오류로 인증에 실패했습니다.',
            message: '잠시 후 다시 시도해 주세요.'
        },

        'only-desktop': {
            title: '브런치 무비 패스는<br>PC에서만 신청이 가능합니다.',
            message: ''
        },

        'success-apply': {
            title: '브런치 작가가 되신 것을<br> 축하드립니다!',
            message: ''
        },

        'success-proposeBlock': {
            title: '제안 받지 않도록 차단했습니다.',
            message: '이 사람에게 다시 제안을 받으려면,<br>고객센터로 문의해 주세요.'
        },

        'follow-magazineToApp': {
            title: '브런치 앱을 설치해보세요!',
            message: "방금 구독한 매거진의 새 글을 <br>'피드'와 '알림'으로 더 편하게<br>받아보실 수 있습니다.",
            actions: [
                DEFAULT_MOBILE_CLOSE_BTN,
                { class: '', action: 'goAppPage', name: '앱 설치하기' }
            ]
        },

        'follow-weeklyMagazineToApp': {
            title: '브런치 앱을 설치해보세요!',
            message: "방금 구독한 매거진의 새 글을 <br>'피드'와 '알림'으로 더 편하게<br>받아보실 수 있습니다.",
            actions: [
                DEFAULT_MOBILE_CLOSE_BTN,
                { class: '#appgo_install', action: 'goAppPage', name: '앱 설치하기' }
            ]
        },

        'follow-userToApp': {
            title: '브런치 앱을 설치해보세요!',
            message: "방금 구독한 작가의 새 글을 <br>'피드'와 '알림'으로 더 편하게<br>받아보실 수 있습니다.",
            actions: [
                DEFAULT_MOBILE_CLOSE_BTN,
                { class: '', action: 'goAppPage', name: '앱 설치하기' }
            ]
        },

        'follow-userToAppInFollowerList': {
            title: '브런치 앱을 설치해보세요!',
            message: "방금 구독한 작가의 새 글을 <br>'피드'와 '알림'으로 더 편하게<br>받아보실 수 있습니다.",
            actions: [
                DEFAULT_MOBILE_CLOSE_BTN,
                { class: '#follower#appgo_install', action: 'goAppPage', name: '앱 설치하기' }
            ]
        },

        'follow-userToAppInFollowingList': {
            title: '브런치 앱을 설치해보세요!',
            message: "방금 구독한 작가의 새 글을 <br>'피드'와 '알림'으로 더 편하게<br>받아보실 수 있습니다.",
            actions: [
                DEFAULT_MOBILE_CLOSE_BTN,
                { class: '#following#appgo_install', action: 'goAppPage', name: '앱 설치하기' }
            ]
        },

        'follow-userToAppInHome': {
            title: '브런치 앱을 설치해보세요!',
            message: "방금 구독한 작가의 새 글을 <br>'피드'와 '알림'으로 더 편하게<br>받아보실 수 있습니다.",
            actions: [
                DEFAULT_MOBILE_CLOSE_BTN,
                { class: '#m_follow#appgo_install', action: 'goAppPage', name: '앱 설치하기' }
            ]
        },

        'follow-userToAppInMagazineAuthor': {
            title: '브런치 앱을 설치해보세요!',
            message: "방금 구독한 작가의 새 글을 <br>'피드'와 '알림'으로 더 편하게<br>받아보실 수 있습니다.",
            actions: [
                DEFAULT_MOBILE_CLOSE_BTN,
                { class: '#m_mag_writers#appgo_install', action: 'goAppPage', name: '앱 설치하기' }
            ]
        },

        'follow-userToAppInPost': {
            title: '브런치 앱을 설치해보세요!',
            message: "방금 구독한 작가의 새 글을 <br>'피드'와 '알림'으로 더 편하게<br>받아보실 수 있습니다.",
            actions: [
                DEFAULT_MOBILE_CLOSE_BTN,
                { class: '#post_view#m_appgo#m_follow_install', action: 'goAppPage', name: '앱 설치하기' }
            ]
        },

        'likeit-toApp': {
            title: '브런치 앱을 설치해보세요!',
            message: '라이킷한 글은 브런치 앱의 <br>[메뉴 > 라이킷 보관함]에서<br>확인하실 수 있습니다.',
            actions: [
                DEFAULT_MOBILE_CLOSE_BTN,
                { class: '#post_view#m_likeit#appgo_install', action: 'goAppPage', name: '앱 설치하기' }
            ]
        },

        'connect-kakao': {
            title: '카카오계정을 연결하시겠습니까?',
            message: '선택 정보 수집에 동의하시려면<br> 카카오계정 연결이 필요합니다.',
            actions: [
                { class: 'btn_close', action: 'close', name: '나중에' },
                { class: '', action: 'goConnectKakao', name: '지금 연결하기' }
            ]
        },

        'error-default': {
            title: '오류가 발생하였습니다.',
            type: 'alert'
        },

        'error-notExistTokenUsingCard': {
            title: '존재하지 않는 초대카드입니다.',
            type: 'alert'
        },

        'error-alreadyAcceptedUsingCardForAccepter': {
            title: '아쉽지만 다른 분이 카드를 사용했어요.',
            message: '신청을 통해 브런치 작가가 되어 보세요!',
            type: 'alert'
        },

        'error-alreadyAcceptedUsingCardForSender': {
            title: '추천하신 분이 브런치 작가가 됐어요.',
            message: '두 분의 창작 활동을 응원하겠습니다!',
            type: 'alert'
        },

        'error-expiredUsingCardForSender': {
            title: '아쉽지만 작가 초대 기한이 지났어요.',
            message: '다른 방법으로 브런치를 추천해 주세요!',
            type: 'alert'
        },

        'error-expiredUsingCardForAccepter': {
            title: '아쉽지만 작가 초대 기한이 지났어요.',
            message: '신청을 통해 브런치 작가가 되어 보세요!',
            type: 'alert'
        },
        'success-checkConnectKakao': {
            title: '카카오계정을 정말<br> 연결하시겠습니까?',
            message: '해당 계정은 카톡에서 쓰는 계정이 아닙니다.<br>톡 계정을 연결하면 더 원활하게<br>브런치를 이용하실 수 있습니다.',
            actions: [
                { class: '', action: 'goCheckKakao', name: '계정 확인' },
                { class: '', action: 'goReConnectKakao', name: '연결하기' }

            ]
        }
    };

    var RE = /#([^:]+):([^:]+)/;
    var loc = document.location;
    var $body = $(document.body);
    var $layer;

    var init = function (messageObject) {
        if (messageObject) {
            MESSAGE = $.extend(true, MESSAGE, messageObject);
        }

        var msg = getMessage(loc.hash);

        if (msg) {
            showMessage(msg);
        }
    };

    var getMessage = function (hash) {
        var msgObj = parse(hash);

        if (!msgObj) {
            return;
        }

        var msg = null;

        if (B.isDebug()) {
            console.log('getMessage msgObj : ', msgObj);
        }

        var type = msgObj.type;
        var value = msgObj.value;

        if (B.UserAgent.isMobile) {
            _trackTiaraPageLog(msgObj);
            HIDE_POPUP = type === 'error' && value === 'duplicate';
            return MESSAGE_MOBILE[type + '-' + value];
        } else {
            HIDE_POPUP = false;
            msg = MESSAGE[type + '-' + value];
        }

        return msg;
    };

    var parse = function (hash) {
        var result = RE.exec(hash);

        if (result) {
            loc.hash = '';

            return {
                type: result[1],
                value: result[2]
            };
        }
    };

    var showMessage = function (msg) {
        if (msg.type == 'alert') {
            var alertMsg = msg.message ? msg.title + '\n' + msg.message : msg.title;
            alert(alertMsg);
            return;
        }

        if ($layer != null) {
            $layer.hide();
        }

        hideKakaoAccountPopup(true);

        if (msg.type === 'welcome') {
            B.Util.ajax({
                url: B.Config.apiUrl + '/v1/me',
                type: 'get',
                async: false,
                success: function (result) {
                    var user = result.data;
                    msg.userName = user.userName;
                    msg.userImage = user.userImage;
                    var templateData = jQuery.extend({ 'isMobile': (B.UserAgent.isMobile) }, msg);
                    $layer = $(B.Util.getTemplate('account-welcome.hbs', templateData));
                    $layer.on('click', onClick);
                    $layer.show();
                    $body.append($layer);
                },
                error: function () {
                    return false;
                }
            });
        } else {
            var templateData = jQuery.extend({ 'isMobile': (B.UserAgent.isMobile) }, msg);
            var hbsName;

            if (msg.type === 'connect') {
                hbsName = 'account-connect.hbs';
            } else {
                hbsName = 'account-message.hbs';
            }

            $layer = $(B.Util.getTemplate(hbsName, templateData));
            $layer.on('click', onClick);
            $body.append($layer);
        }

    };

    var onClick = function (e) {
        var $btn = _getActionButton($layer, e.target);
        var action = $btn.data('action');
        e.preventDefault();

        if (action == 'close' || action == 'ok') {
            hideAll();
        } else if (action == 'goMyHome') {
            if (B.User.userId) {
                location.href = '/@@' + B.User.userId;
            } else {
                location.href = '/?signin';
            }
        } else if (action == 'signin') {
            location.href = '/?signin';
        } else if (action == 'goWrite') {
            location.href = '/write';
        } else if (action == 'goSetting') {
            var lastPath = document.location.pathname;

            if (lastPath == '/write') {
                window.open('/me/settings');
            } else {
                location.href = '/me/settings';
            }
        } else if (action == 'goSettingNewWindow') {
            window.open('/me/settings');
        } else if (action == 'goNotice') {
            window.open('https://brunch.co.kr/@brunch/1');
        } else if (action == 'goRequest') {
            window.open('/apply');
        } else if (action == 'goDesk') {
            window.open('http://www.kakao.com/requests?locale=ko&service=54');
        } else if (action == 'goEmailService') {
            openEmailService();
        } else if (action == 'goRequestDirect') {
            var pathName = location.pathname;

            if (pathName == '/apply' || pathName == '/makebook') {
                location.href = pathName + '?form';
            } else {
                location.href = '/apply?form';
            }
        } else if (action == 'goAppPage') {
            window.open('/app/go');
        } else if (action == 'goProfileNotice') {
            location.href = 'https://brunch.co.kr/@brunch/136';
        } else if (action == 'goWeeklyMagazineNotice') {
            window.open('https://brunch.co.kr/@brunch/105');
        } else if (action == 'goProfile') {
            window.open('/me/profile');
        } else if (action == 'goConnectKakao') {
            goConnectKakao();
        } else if (action == 'goReadyBrunchbook') {
            location.href = '/ready#brunchbook';
        } else if (action == 'getTempContent') {
            getTempContent();
        } else if (action == 'deleteTempContent') {
            deleteTempContent();
        } else if (action == 'goReConnectKakao') {
            goReConnectKakao();
        } else if (action == 'goCheckKakao') {
            window.open('/kakao/account/info');
        } else if (action == 'goBrunchGuide') {
            window.open('/magazine/brunchupdate');
        } else if (action == 'goTalkChannel') {
            window.open('https://pf.kakao.com/_YYcYV/friend');
        }

        if (IS_JOIN || IS_VERIFY) {
            _trackTiaraClickLog(action);
        }
    };

    var goReConnectKakao = function () {

        var newForm = document.createElement('form');
        newForm.action = '/connect/kakao';
        newForm.method = 'post';
        newForm.type = 'submit';

        var input = document.createElement('input');
        input.setAttribute('type', 'hidden');
        input.setAttribute('value', jQuery(location).attr('pathname'));
        input.setAttribute('name', 'url');

        newForm.appendChild(input);
        document.body.appendChild(newForm);
        newForm.submit();
    };

    var openEmailService = function (e) {

        var $emailInput = $('[name=email]');
        var emailValue = $emailInput.val();

        if (emailValue != null && B.Util.isValidEmail(emailValue)) {
            var emailDomain = emailValue.replace(/.*@/, '');
            window.open('http://' + emailDomain);
        } else {
            hideAll();
        }

    };

    var hideAll = function () {
        hideKakaoAccountPopup(false);
        $('.dimmed_layer').hide();
        $layer.hide();
    };

    var getTempContent = function () {
        $layer.hide();
        B.Editor.getTempContent();
    };

    var deleteTempContent = function () {
        $layer.hide();
        B.Editor.deleteTempArticle();
    };

    var goConnectKakao = function () {
        $('.connect_form.kakao').submit();
    };

    var _getActionButton = function (container, target) {
        var $btn = $(target);
        while (!$btn.is(container) && !$btn.data('action')) {
            $btn = $btn.parent();
        }

        return $btn;
    };

    function hideKakaoAccountPopup (hide) {
        var connect = jQuery('#reset_connect_kakao');

        if (connect.length <= 0) {
            return;
        }

        if (hide) {
            connect.hide();
        } else {
            connect.show();
        }
    }

    B.Message = {
        init: function (messageObject) {
            init(messageObject);
        },
        showMessage: function (hash) {
            var msg = getMessage(hash);
            showMessage(msg);
        },
        showSimpleMessage: function (msg) {
            showMessage(msg);
        },
        getAjaxOptions: function (options) {
            return $.extend({
                xhrFields: {
                    withCredentials: true
                },
                crossDomain: true,
                type: 'GET'
            }, options);
        },
        reConnectKakao: function () {
            goReConnectKakao();
        }
    };

    jQuery($body).click(function (event) {
        var $target = $(event.target);

        if (!HIDE_POPUP) {
            return;
        }

        var $innerAccountLayer = jQuery('.inner_account_layer');

        if ($innerAccountLayer.length <= 0) {
            return;
        }

        if (!$target.closest('.inner_account_layer').length
            && $innerAccountLayer.is(':visible')) {
            $innerAccountLayer.hide();
        }
    });
    var _trackTiaraClickLog = function (action) {
        var page = T.newClick().setSection('dialogue');

        if (IS_JOIN) {
            page.setPage('welcome');

            if (action == 'close') {
                page.setName('팝업 > 가입 완료 안내 팝업 > 닫기 버튼 클릭')
                    .setLayer1('close');
            } else if (action == 'goTalkChannel') {
                page.setName('팝업 > 가입 완료 안내 팝업 > 우측 버튼 클릭')
                    .setLayer1('button_right');
            } else if (action == 'goBrunchGuide') {
                page.setName('팝업 > 가입 완료 안내 팝업 > 좌측 버튼 클릭')
                    .setLayer1('button_left');
            }

        } else if (IS_VERIFY) {
            page.setPage('verify');

            if (action == 'close') {
                page.setName('팝업 > 메일 인증 완료 안내 팝업 > 닫기 버튼 클릭')
                    .setLayer1('close');
            } else if (action == 'goTalkChannel') {
                page.setName('팝업 > 메일 인증 완료 안내 팝업 > 버튼 클릭')
                    .setLayer1('button');
            }
        }

        page.track();
    };

    var _trackTiaraPageLog = function (msgObj) {
        var type = msgObj.type;
        var value = msgObj.value;

        if (type == 'success' && (
            value.indexOf('join') != -1
            || value == 'verify'
            || value == 'specific'
            || value == 'verified')) {

            var page = T.newPage()
                .setSection('dialogue');

            if (value.indexOf('join') != -1) {
                IS_JOIN = true;
                page.setPage('welcome')
                    .setName('팝업 > 가입 완료 안내 팝업');
            } else {
                IS_VERIFY = true;
                page.setPage('verify')
                    .setName('팝업 > 메일 인증 완료 안내 팝업');
            }

            page.track();
        }
    };
})(jQuery);
